import get from 'lodash.get';

export const selectPromotionData = (state) => get(state, 'promotion.data', null);

export const selectCurrentPromotions = (state) => get(state, 'promotion.data.current', null);
export const selectFuturePromotions = (state) => get(state, 'promotion.data.future', null);
export const selectPromotionsCurrentTab = (state) => get(state, 'promotion.currentTab', null);
export const selectPromotionSelectedProduct = (state) =>
  get(state, 'promotion.selectedProduct', null);
